import { useQuery } from "@tanstack/react-query";

import { sanitizeCounters, type PlatformCounters } from "../../shared/platformCounters";

/**
 * Load the live customer counters from the site's own API, which reads the ERP.
 *
 * Any failure is `null`, and `null` keeps the line the hero shows today.
 */
export function usePlatformCounters(): PlatformCounters | null {
  const { data } = useQuery({
    queryKey: ["platform-counters"],
    staleTime: 60 * 60 * 1000,
    retry: false,
    queryFn: async () => {
      const res = await fetch("/api/platform-counters");
      return res.ok ? sanitizeCounters(await res.json()) : null;
    },
  });
  return data ?? null;
}
